// redux
export const VISITED_APP = 'location/VISITED_APP';
export const VISITED_CANVAS = 'location/VISITED_CANVAS';
export const VISITED_COMPONENT = 'location/VISITED_COMPONENT';
export const VISITED_CONTRACT = 'location/VISITED_CONTRACT';
export const VISITED_FOLDER = 'location/VISITED_FOLDER';
export const VISITED_LOGIN = 'location/VISITED_LOGIN';
export const VISITED_LOGOUT = 'location/VISITED_LOGOUT';
export const VISITED_NAUTH = 'location/VISITED_NAUTH';
export const VISITED_PAGE = 'location/VISITED_PAGE';
export const VISITED_REPORTS = 'location/VISITED_REPORTS';
export const VISITED_ROOT = 'location/VISITED_ROOT';
export const VISITED_SEARCH = 'location/VISITED_SEARCH';
export const VISITED_VERSION = 'location/VISITED_VERSION';

// other
export const PATHNAME_APP = '/app';
export const PATHNAME_CANVAS = '/canvas';
export const PATHNAME_COMPONENT = '/app/component/:id';
export const PATHNAME_CONTRACT = '/contract';
export const PATHNAME_FOLDER = '/app/folder/:id';
export const PATHNAME_LOGIN = '/login';
export const PATHNAME_LOGOUT = '/logout';
export const PATHNAME_NAUTH = '/nauth';
export const PATHNAME_PAGE = '/app/page/:id';
export const PATHNAME_REPORTS = '/reports/:reportName';
export const PATHNAME_ROOT = '/';
export const PATHNAME_SEARCH = '/app/search';
export const PATHNAME_VERSION = '/version';
